import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withTranslation } from 'react-i18next';
import { ListItemIcon, List, Collapse, withStyles } from '@material-ui/core';
import Toggle from 'react-toggled';
import ReactCountryFlag from 'react-country-flag';
import TextsmsOutlinedIcon from '@material-ui/icons/TextsmsOutlined';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import { EmptyIcon, styles } from './SidebarHelpers';
import { canShowFlagEmoji } from '../../utils/platform';
class LangSelector extends React.Component {
    constructor() {
        super(...arguments);
        this.selectLang = (lang) => {
            const { setLangSelected } = this.props;
            localStorage.setItem('speechLang', lang);
            setLangSelected(lang);
        };
    }
    render() {
        const { speechLang, availableLangs, classes, t } = this.props;
        const langs = [];
        Object.keys(availableLangs).forEach((key) => {
            langs.push({
                value: availableLangs[key].languageCode,
                key,
                flagCode: availableLangs[key].flagCode,
            });
        });
        const lang = langs.find((l) => l.value === speechLang) || {};
        const currentFlagCode = lang && lang.flagCode;
        return (React.createElement(Toggle, null, ({ on, getTogglerProps, setOff }) => (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(ListItem, Object.assign({ key: "lang_selected", button: true }, getTogglerProps()),
                React.createElement(ListItemIcon, null,
                    React.createElement(TextsmsOutlinedIcon, null)),
                React.createElement(ListItemText, { style: { paddingRight: 0 } },
                    t('micSettings.chooseLang'),
                    React.createElement("br", null),
                    currentFlagCode && (React.createElement(ReactCountryFlag, { style: { marginRight: 5 }, svg: !canShowFlagEmoji(), countryCode: currentFlagCode })),
                    React.createElement("b", null, lang.key)),
                React.createElement(ListItemIcon, { style: { marginRight: 0, minWidth: 0 } }, on ? React.createElement(ExpandLessOutlinedIcon, null) : React.createElement(ExpandMoreOutlinedIcon, null))),
            React.createElement(Collapse, { in: on },
                React.createElement(List, null, langs.map((lang_) => (React.createElement(ListItem, { key: lang_.value, button: true, style: {
                        display: lang === lang_ ? 'none' : undefined,
                    } },
                    React.createElement(EmptyIcon, null),
                    React.createElement(ListItemText, { classes: { root: classes.listItemText }, onClick: () => {
                            this.selectLang(lang_.value);
                            setOff();
                        } },
                        React.createElement(ReactCountryFlag, { style: { marginRight: 5 }, svg: !canShowFlagEmoji(), countryCode: lang_.flagCode }),
                        lang_.key))))))))));
    }
}
export default withStyles(styles)(withTranslation()(withTheme(LangSelector)));
